import React from "react";
import { Button, Modal, Card } from "react-bootstrap";
import Alert from "components/Common/Alert";
import TreeMenu from "react-simple-tree-menu";
import "../../../../../../node_modules/react-simple-tree-menu/dist/main.css";
import { loadEmSitesListStart } from "services/redux/actions/enterpriseManager";
import conxtdOut from "apis/conxtdOut";
import { connect } from "react-redux";
import Icon from "components/Icons/Icon";
import "./MoveSite.scss";

class MoveSite extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newGroupId: null,
      hasChildrenGroup: null,
    };
  }
  render() {
    const { darkMode, handleShow } = this.props
    const handleChangeMoveSite = async (event) => {
      const checkboxSelection = this.props.checkboxSelection;
      const existing_groups = this.props.existing_groups;

      if (this.state.hasChildrenGroup === true) {
        Alert({
          text: "Parent group selection is not allowed.",
          icon: "warning",
        });
      } else {
        try {
          await conxtdOut.post(`/EnterpriseStructure/moveSitesToGroup/`, {
            new_group_id: this.state.newGroupId,
            old_group_id: this.props.groupId,
            selected_sites: checkboxSelection,
            existing_groups: existing_groups,
          });
          this.props.dispatch(
            loadEmSitesListStart({
              enterprise_group_id: this.props.groupId,
            })
          );
          Alert({
            text: "Selected sites have been moved.",
            icon: "success",
            timerProgressBar: true,
            timer: 1500,
          });
          // wait 10 secs before closing modal
          await new Promise((resolve) => setTimeout(resolve, 1000));
          this.props.onHide();
        } catch (error) {
          let apiError = error.response.data.message;
          let customError = error.response.data.message;

          if (
            apiError.includes("duplicate key value violates unique constraint")
          ) {
            customError = "Cannot move site if it's already in the group.";
          } else {
            return customError;
          }
          Alert({
            text: customError,
            icon: "error",
          });
        }
      }
    };

    return (
      <>
        <Button
          variant={darkMode ? 'primary' : 'light'}
          type="submit"
          className="action-button"
          id="move-button"
          onClick={handleShow}
        >
          <Icon className="fas fa-file-import icons" />
          <span className="action-text">Move</span>
        </Button>
        <Modal
          show={this.props.show}
          onHide={this.props.onHide}
          backdrop="static"
          keyboard={false}
          className="modal"
          dialogClassName="move-site-modal"
        >
          <Modal.Header closeButton>
            <div>
              <Card.Title
                id="contained-modal-title-vcenter"
                style={{ marginRight: "100px" }}
              >
                Move selected sites to..{" "}
              </Card.Title>
              <div
                style={{
                  display: "flex",
                  flexWrap: "nowrap",
                  flexGrow: 1,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <TreeMenu
                    data={this.props.treeData}
                    onClickItem={({ key, ...props }) => {
                      // Exclude parent Ids
                      const getLastIndex = key.lastIndexOf("/");
                      const newKey = key.substring(getLastIndex + 1);

                      const hasChildrenGroup = props.hasNodes;
                      console.log(this.props);
                      this.setState({
                        newGroupId: newKey,
                        hasChildrenGroup,
                      });
                    }}
                  />
                </div>
              </div>{" "}
            </div>
          </Modal.Header>

          <Modal.Footer>
            <Button
              variant="success"
              type="submit"
              onClick={handleChangeMoveSite}
            >
              Move
            </Button>

            <Button variant="primary" onClick={this.props.onHide}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
    loadEmSitesListStart,
    darkMode: state.app.darkMode,
  };
};
export default connect(mapStateToProps)(MoveSite);
